import { AdminHelpManagement } from '@/components/admin/helps/AdminHelpManagement';
import { useLanguage } from '@/contexts/LanguageContext';

export function AuditDashboard() {
  const { t } = useLanguage();

  return (
    <AdminHelpManagement
      titleOverride={t('dashboard.audit.title')}
      descriptionOverride={t('dashboard.audit.description')}
      readOnly
    />
  );
}
